import { useCurrentPractice } from 'contexts/PracticeContext'
import { isEmpty } from 'lodash'
import { useMemo } from 'react'
import { Navigate } from 'react-router-dom'
import { isIndependentPractice } from '../util/practice'

const ActivePracticeGuard = ({ children }) => {
	const { currentPracticeObject, isCurrentPracticeActive } = useCurrentPractice()

	const isSMBPractice = useMemo(
		() => !isEmpty(currentPracticeObject) && isIndependentPractice(currentPracticeObject),
		[currentPracticeObject]
	)

	if (isSMBPractice && !isCurrentPracticeActive) {
		return <Navigate to="/dashboard" replace />
	}

	return children
}

export default ActivePracticeGuard
